import { createContext } from "react";

const data = localStorage.getItem("roleData")
export const RoleContext = createContext(JSON.parse(data));